module.exports = __webpack_public_path__ + "img/avatar6.d1c211cd.png";